import { useEffect } from 'react';

import { RnsEventBus } from 'features/call/call-events';
import { useColdHandoffRnsHandlers } from 'features/cold-handoff/hooks';
import { useWhileComponentMounted } from 'features/utils/hook';

export const useColdHandoffSearchRnsHandlers = () => {
  const whileComponentMounted = useWhileComponentMounted();
  const { handleColdHandoffAccepted } = useColdHandoffRnsHandlers();

  useEffect(() => {
    RnsEventBus.$coldHandoffAccepted
      .pipe(whileComponentMounted())
      .subscribe(handleColdHandoffAccepted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
